import { WebActionSource } from "@snapchat/web-blizzard-reporting";
import { FooterCard, Snapcode } from "@snapchat/web-core-ui";
import { isErrorState, isLensActive, isLensLoading, isLensInactive, } from "@snapchat/web-live-lens";
import { LensNameWithLensSuffix } from "../../../../common/LensNameWithLensSuffix";
import { TryLensCTA } from "../../../TryLensCTA";
import { FindMoreLenses } from "../../FindMoreLenses";
import { OpenInAppCTA } from "../OpenInAppCTA";
import styles from "./MobileLensFooter.module.css";
import { LensCreatorTags } from "../../LensCreatorTags";
import getMoreContentOptionTabs from "../../MoreContentOptions";
export function MobileLensFooter({ lensName, snapcodeImageUrl, spotlightsUsingThisLens, spotlightOption, lensCreatorDisplayName, lensCreatorTags, userProfileUrl, iconUrl, onTryLensClick, canTryLens, liveLensState, openInSnapchatLink, pageType, moreLenses, }) {
    const snapcodeAlt = `Scan this Snapcode using the Snapchat app to use the ${lensName} Lens by ${lensCreatorDisplayName}`;
    const snapCode = snapcodeImageUrl && (<Snapcode snapcodeImageUrl={snapcodeImageUrl} size="xsmall" alt={snapcodeAlt}/>);
    const headerContent = (() => {
        if (canTryLens) {
            if (isLensInactive(liveLensState)) {
                return <TryLensCTA onClick={onTryLensClick} lensName={lensName} isMobile/>;
            }
            else if (isLensActive(liveLensState)) {
                return (<OpenInAppCTA pageType={pageType} openInSnapchatLink={openInSnapchatLink} actionSource={WebActionSource.MobileLensPreview}/>);
            }
            else if (isErrorState(liveLensState)) {
                return <TryLensCTA onClick={onTryLensClick} lensName={lensName} isMobile isRetry/>;
            }
            /* istanbul ignore next : Remove once test code is added */
            if (isLensLoading(liveLensState)) {
                return null;
            }
        }
        return snapCode;
    })();
    const tabs = getMoreContentOptionTabs("mobile-lens-profile", "small", lensName, spotlightOption, spotlightsUsingThisLens, moreLenses);
    return (<div className={styles.footerContainer}>
      <div className={styles.footerForMobileNav}>
        <FooterCard iconUrl={iconUrl} title={<LensNameWithLensSuffix lensName={lensName}/>} subtitle={userProfileUrl ? (<ClickableDisplayName lensCreatorDisplayName={lensCreatorDisplayName} userProfileUrl={userProfileUrl}/>) : (lensCreatorDisplayName)} headerContent={headerContent} footerContent={lensCreatorTags?.length ? <LensCreatorTags creatorTags={lensCreatorTags}/> : undefined}/>

        {tabs}
        <div className={styles.findMoreLensesContainer}>
          <FindMoreLenses thumbnailCount={2} isMobile/>
        </div>
      </div>
    </div>);
}
function ClickableDisplayName({ userProfileUrl, lensCreatorDisplayName, }) {
    return (<a href={userProfileUrl} className={styles.link}>
      {lensCreatorDisplayName}
    </a>);
}
